import React from "react";
import "../styles/Legal.css";

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p>
        At Globisun Energies, we value your privacy and are committed to protecting your personal data. This policy outlines how we collect, use, and protect your information.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We collect personal data such as name, email, phone number, and user category when you sign up on our platform.</p>

      <h2>2. How We Use Your Data</h2>
      <ul>
        <li>To provide and improve our services</li>
        <li>To contact you about your account</li>
        <li>To send relevant offers or updates</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2>3. Data Protection</h2>
      <p>
        We implement industry-standard security measures to protect your data. Your information is not shared with third parties without your consent unless required by law.
      </p>

      <h2>4. User Rights</h2>
      <p>
        You have the right to access, correct, or delete your data. You may also withdraw your consent at any time by contacting us.
      </p>

      <h2>5. Contact</h2>
      <p>
        If you have any questions about our privacy policy, contact us at:  
        <br />
        <strong>Email:</strong> globisunsolar@gmail.com 
        <br />
        <strong>Phone:</strong> +234 813 129 9300
      </p>
    </div>
  );
}
